module.exports = __webpack_public_path__ + "static/media/badge.9fa14f1f.svg";